"use strict";

exports.__esModule = true;
var _exportNames = {
  CrossChain: true
};
exports.CrossChain = void 0;
var _rxjs = require("rxjs");
var _crossChainRouter = require("./cross-chain-router");
var _errors = require("./errors");
var _adapters = require("./adapters");
Object.keys(_adapters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _adapters[key]) return;
  exports[key] = _adapters[key];
});
class CrossChain {
  constructor(_ref) {
    let {
      adapters
    } = _ref;
    this.router = void 0;
    this.adapters = void 0;
    this.consts = void 0;
    this.isReady$ = void 0;
    this.findAdapter = chain => {
      const result = this.router.findAdapterByName(chain);
      if (!result) throw new _errors.NoCrossChainAdapterFound(JSON.stringify(chain));
      return result;
    };
    this.isReady$ = new _rxjs.BehaviorSubject(false);
    this.adapters = adapters;
    this.router = new _crossChainRouter.CrossChainRouterManager({
      adapters: adapters
    });
    this.init();
  }
  init() {
    this.adapters.forEach(i => this.router.addRouters(i.getRouters()));
    this.adapters.forEach(i => i.injectFindAdapter(this.findAdapter));
    this.isReady$.next(true);
  }
  get isReady() {
    return (0, _rxjs.firstValueFrom)(this.isReady$.asObservable().pipe(i => i));
  }
}
exports.CrossChain = CrossChain;